<template>
  <div class="avatar">
    <div
      class="avatar__placeholder"
      :style="{ 'background-image': `url('${avatarImageSource}')` }"
      v-if="avatarImageSource"
    ></div>
  </div>
</template>

<script>
import repository from '@/core/repository/entity-repository'

export default {
  props: ['polygonPersonId', 'technician', 'imageSource'],
  data: () => ({
    avatarImageSource: null,
    dummySource: require(`@/assets/images/avatar-default.png`)
  }),
  mounted() {
    if (this.technician && this.technician.imageSource) {
      this.loadImage(this.technician.imageSource)
    } else if (this.imageSource) {
      this.loadImage(this.imageSource)
    } else if (this.polygonPersonId) {
      repository.getPolygonEmployee(this.polygonPersonId).done(tech => {
        if (tech.imageSource) {
          this.loadImage(tech.imageSource)
        } else {
          this.loadImage(this.dummySource)
        }
      })
    } else {
      this.loadImage(this.dummySource)
    }
  },
  methods: {
    loadImage(src) {
      let img = new Image()
      img.onload = () => {
        this.avatarImageSource = img.src
      }
      img.onerror = () => {
        this.avatarImageSource = this.dummySource
      }
      img.src = src
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar {
  position: relative;
  width: 2.5rem;
  height: auto;
  border: 0.0625rem solid transparent;
  border-radius: 100%;
  background-color: color(primary-light);
  overflow: hidden;
  &:before {
    content: "";
    display: block;
    padding-top: 100%;
  }
}

.avatar__placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: top center;
}
</style>
